import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PuntReturnTouchdownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            (play.historyContains(FootballState.Returned) ||
                play.historyContains(FootballState.NoRecoveryKickReturn)) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const puntFragment =
            play.getPreceedingFragment(fragment, [
                FootballState.Returned,
                FootballState.NoRecoveryKickReturn
            ]) || fragment;

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: puntFragment.returnedBy.teamId,
            playerId: puntFragment.returnedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: puntFragment.id,
            category: FootballStatsCategory.PUNT_RETURN,
            values: {
                touchdowns: 1
            }
        });
    }
}
